<ul class="pcg-search-result-list">
    <li *ngFor="let item of searchResult.pageItems" class="pcg-search-result-list__item">
        <pcg-ng-content-item-details-card
            [itemToDisplay]="item">
        </pcg-ng-content-item-details-card>
    </li>
</ul>
